import { termoUsoService } from '../_services/';
import alerts from '../_components/alerts';
import Swal from 'sweetalert2';

export const termoUsoAction = {
    getTermoUso,
    getTermoUsoById,
    onChangeProps,
    createTermoUso,
    editTermoUsoInfo,
    deleteTermoUsoById,
    onChangePropsConteudoArquivo,
    clear
};

function getTermoUso(showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'termosUso';
        termoUsoService.get(apiEndpoint)
            .then((response) => {
                dispatch(changeTermoUsosList(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            })
    };
}

function editTermoUsoInfo(id, payload) {
    return dispatch => {
        let apiEndpoint = 'termosUso/' + id;
        termoUsoService.put(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(updatedUserInfo());
                    alerts.success(ret.message, '/termosUsos');

                } else {
                    alerts.warning(response.request.responseText);
                }
            })
    }
}

function getTermoUsoById(id, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'termosUso/' + id;
        termoUsoService.get(apiEndpoint)
            .then((response) => {
                dispatch(editTermoUsosDetails(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            })
    };
}

function createTermoUso(payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'termosUso/';
        termoUsoService.post(apiEndpoint, payload)
            .then((response) => {
                if (response != undefined && response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(createUserInfo());
                    if (showWaiting) {
                        alerts.clean();
                    }
                    dispatch(clear());
                    alerts.success(ret.message, '/termosUsos');
                } else {
                    alerts.warning(response.data.Message);
                }
            })
    }
}

function deleteTermoUsoById(id) {
    return dispatch => {
        Swal.fire({
            title: 'Confirmação',
            text: 'Tem certeza de que deseja excluir o registro?',
            icon: 'warning',
            buttons: true,
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: "Não, cancelar!",
            dangerMode: true,
            heightAuto: false
        })
            .then((willDelete) => {
                if (willDelete.value) {
                    let apiEndpoint = 'termosUso/' + id;
                    termoUsoService.deleteDetail(apiEndpoint)
                        .then((response) => {
                            if (response.request.status === 200) {
                                var ret = JSON.parse(response.request.responseText);
                                dispatch(deleteTermoUsosDetails());
                                dispatch(getTermoUso());
                                alerts.success(ret.message);
                            } else {
                                alerts.warning(response.request.responseText);
                            }
                        }).catch((err) => {
                            console.log(err.response);
                            return err.response;
                        })
                }
            });
    };
}

function onChangeProps(props, event) {
    return dispatch => {
        dispatch(handleOnChangeProps(props, event.target.value));
    }
}
function onChangePropsConteudoArquivo(props, event) {
    return (dispatch) => {
        dispatch(handleOnChangeProps(props, event))
    }
}

export function changeTermoUsosList(termoUso) {
    return {
        type: "FETECHED_ALL_TERMO_USO",
        termoUso: termoUso
    }
}

export function clear() {
    return {
        type: "TERMO_USO_CLEAR"
    };
}

export function handleOnChangeProps(props, value) {
    return {
        type: "HANDLE_ON_CHANGE",
        props: props,
        value: value
    }
}

export function editTermoUsosDetails(termoUso) {
    return {
        type: "TERMO_USO_DETAIL",
        id: termoUso.id,
        versao: termoUso.versao,
        link: termoUso.link,
        sistema: termoUso.sistema,
        conteudo_arquivo: termoUso.conteudo_arquivo,
        data_cadastro: termoUso.data_cadastro,
        usuario_cadastro: termoUso.usuario_cadastro,
        data_exclusao: termoUso.data_exclusao,
        usuario_exclusao: termoUso.usuario_exclusao
    }
}

export function updatedUserInfo() {
    return {
        type: "TERMO_USO_UPDATED"
    }
}

export function createUserInfo() {
    return {
        type: "TERMO_USO_CREATED_SUCCESSFULLY"
    }
}

export function deleteTermoUsosDetails() {
    return {
        type: "DELETED_TERMO_USO_DETAILS"
    }
}